import React from 'react';
import MatGapCoreTransactionList from './MatGapCoreTransactionList';

export default function MatGapReturnList() {
  return (
    <MatGapCoreTransactionList
      title="GAP Material - Return Transactions"
      opTypes={["return"]}
    />
  );
}
